<template>
  <div class="modal" v-if="seen">
    <template v-if="!state">
      <div class="permanent" v-if="!done">
        <span>Moving <strong>{{ str_text(file) }}</strong> to <strong>{{ str_text(dest_folder) }}</strong></span>
        <span><img src="@/assets/30.gif" /></span>
      </div>
      <div class="loading" v-if="done">
        <p><span class="note"><strong style="font-weight:bold;">{{ movedfile }}</strong> moved to <strong
              style="font-weight:bold;">{{ destination }}</strong></span></p>
        <p><span class="btn cancel" @click="closebox">Ok</span> &nbsp;&nbsp; <span class="btn ok" @click="goto">Go to
            location </span></p>
      </div>
    </template>
    <template v-else>
      <div class="deletefile">
        <span @click="closebox" class="closefile">
          <img src="@/assets/Close Button.svg" />
        </span>
        <div class="header d-flex justify-content-center align-items-center mt-2">
          <h6><strong>Move file?</strong></h6>
        </div>
        <div class="cgn text-center mb-2">
          <span>Do you want to move <strong>{{ str_text(file) }}</strong> to <strong>{{ str_text(dest_folder)
          }}</strong>?</span>
        </div>
        <div class="save">
          <span class="btn-delete-permanently" @click="closebox">
            Cancel
          </span>
          <span class="btn-move-to-trash" @click="move">
            Move
          </span>
        </div>
      </div>
    </template>
  </div>
</template>
<style scoped>
.header {
  padding: .5em 0 0 0 !important;
}

.header h3 {
  font-size: 22px;
  font-weight: bold;
}

.save {
  margin-top: 0 !important;
}

.cgn {
  display: flex;
  flex-direction: column;
}

.cgn span {
  margin-bottom: .4em;
  font-size: 14px;
}

.deletefile {
  padding: 2em !important;
}

.modal div.deletefile {
  width: 420px !important;
}

.modal div.deletefile div {
  width: 100% !important;
  margin-left: 0 !important;
}

.save {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.save span {
  flex: 1 !important;
}

.save .btn-move-to-trash {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}

.save .btn-delete-permanently {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.save .btn-delete {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal div.deletefile .closefile {
  top: 13px !important;
  right: 13px !important;
}

.modal .loading {
  flex-direction: column;
}

.modal .cancel {
  background: transparent !important;
  border: 1px solid #FC6D6C !important;
  font-size: 13px !important;
  color: #FC6D6C !important;
}

.modal .ok {
  background: #3F96D1 !important;
  color: #fff !important;
  font-size: 13px !important;
}
</style>

<script>
import cookies from '@/services/cookies'
import { mapMutations } from 'vuex'
export default {
  data() {
    return {
      dest_id: '',
      dest_folder: '',
      file_id: '',
      file: '',
      seen: false,
      index: null,
      loader: false,
      error: false,
      id: null,
      found: false,
      is_public: false,
      is_group: false,
      src: '',
      state: true,
      done: false
    }
  },
  methods: {
    ...mapMutations([
      'SET_DIRECTORY_CHILDREN',
      'SORT_DIRECTORY_CHILDREN',
      'SORT_STORED_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      return str.length > 60 ? str.substr(0, 60) + '...' : str
    },
    load(folder, file, index) {
      this.seen = true
      this.error = false
      this.loader = false
      this.dest_folder = folder.dir
      this.file = file.dir
      this.file_id = file.id
      this.dest_id = folder.id
      this.index = index
      this.state = true
      this.done = false
    },
    refreshfolder() {
      // this.$parent.loading(true);
      let data = {
        token: cookies.getCookie("token"),
        current_directory_id: localStorage.getItem("current_directory_id"),
        db: localStorage.getItem("db"),
        filepath: sessionStorage.getItem("filepath"),
      };

      let that = this;

      this.$socket.emit("refresh", data, function (data) {
        if (data.data === true) {
          that.SET_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children);
          that.SET_PATH(data.dir_path);
          that.SORT_DIRECTORY_CHILDREN();
          // that.$parent.loading_close();
        }

        if (data.data === false) {
          // that.$parent.loading_close();
          //that.logincall();
          that.$router.push('/login')
        }
      });
    },
    move() {
      let that = this

      let data = {
        token: cookies.getCookie('token'),
        move_file_id: this.file_id,
        selected_folder_id: this.dest_id,
        ignore: false
      }

      this.done = true

      this.$socket.emit('move_file', data, function (data) {
        if (data.message === 'completed') {
          that.done = true
          that.destination = data.destination
          that.movedfile = data.movedfile
          that.dir = data.dir
          that.selected_folder_id = data.dir.id
          // that.$store.getters.DIRECTORY_CHILDREN.splice(that.index, 1)
          that.refreshfolder()
          // that.seen = false
          that.state = false
          // let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          // that.UPDATE_TOTAL_USED_SPACE(total_space_used)
        }

        if (data.message === 'exist') {
          that.seen = false
          that.fileExist(data.new_name)
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    goto() {
      if (this.selected_folder_id) {
        this.loading = false
        this.wait = false

        let that = this

        let data = {
          db: this.dir.db,
          token: cookies.getCookie('token'),
          current_directory_id: this.selected_folder_id
        }

        this.$socket.emit('browse', data, function (data) {
          if (data.message === 'completed') {
            localStorage.setItem('current_directory_id', that.selected_folder_id)
            localStorage.setItem('current_directory', that.dir.name)
            localStorage.setItem('db', that.dir.db)
            that.SET_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_CURRENT_DIRECTORY(that.dir.name)
            that.SET_PATH(data.dir_path)
            that.SORT_DIRECTORY_CHILDREN()
            that.seen = false
          }

          if (data.data == false) {
            that.seen = false
            that.logincall()
            that.$router.push('/login')
          }
        })
      }
    },
    fileExist(new_name) {
      this.$parent.file_exist(0, this.file_id, this.dest_id, new_name, 'move')
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>
